import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 24.28 23.09",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.28 23.09\" stroke-width=\"2\" id=\"star\">\n    <path d=\"M12.14,0l2.64,8.13.23.69h9.27l-6.92,5-.58.43L17,15l2.64,8.12-6.91-5-.6-.42-.58.43-6.91,5L7.28,15l.22-.69-.59-.42L0,8.82H9.27l.23-.7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol